const state = {
    update: null,
    registered: false, // 是否已注册路由
};

// getters
const getters = {
    update: state => state.update,
    registered: state => state.registered,
};

// mutations
const mutations = {
    changeUpdate(state, value) {
        state.update = value;
    },
    changeRegistered(state, value) {
        state.registered = value;
    },
};

const actions = {
};

export default {
    state,
    getters,
    mutations,
    actions
}
